<template>
  <div class="press">
    <div class="campus">电商管理
      <span>></span>
      推荐教材管理
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">推荐教材</div>
          <div class="class_type">
            <span style="display:inlineBlack;">置顶推荐: </span>
            <el-select v-model="stick" @change="getcourselist()">
              <el-option v-for="(item,index) in stickList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="tableStyle">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="picurl" label="教材封面" align="center">
                <template slot-scope="scope"><img height="80px" v-if="scope.row.picurl" :src="scope.row.picurl" alt="">
                  <span v-else>暂无头像</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="课程名称" align="center">
              </el-table-column>
              <el-table-column prop="shortname" label="课程简称" align="center">
              </el-table-column>
              <el-table-column prop="createDate" label="创建时间" align="center">
              </el-table-column>
              <el-table-column prop="recom" label="是否推荐" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.recom" active-color="#13ce66" inactive-color="#CCCCCC" @change="stickYesOrNo(scope.row)">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="recomNumber" label="推荐值(0~10)" align="center">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.recomNumber" :disabled="scope.row.recom===false" :min="0" :max="10" @change="recommend(scope.row)"></el-input-number>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dz-flex dz-flex-justify-end mt-12">
            <el-pagination background @size-change="getcourselist" @current-change="getcourselist" :current-page.sync="page" :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const FormRules = {
  name: [
    {
      required: true,
      message: '请输入课程名称',
      trigger: ['blur', 'change'],
    },
  ],
  price: [
    {
      required: true,
      message: '请输入价格',
      trigger: ['blur', 'change'],
    },
  ],
  seqnum: [
    {
      required: true,
      message: '请选择或输入数量',
      trigger: ['blur', 'change'],
    },
  ],
  abbreviation: [
    {
      required: true,
      message: '请选择类型',
      trigger: ['blur', 'change'],
    },
  ],
};
export default {
  data() {
    return {
      disabled:'',
      value1: '',
      FormRules,
      searchName: '',
      tableData: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 10,
      total: 0,
      stickList: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '推荐',
          value: true,
        },
        {
          label: '未推荐',
          value: false,
        },
      ],
      stick: '',
      classtypes: '',
      chooseClass: [],

      typeLabelValue: '',
      forms: {
        abbreviation: '',
        name: '',
        price: '',
        details: '',
        seqnum: '',
        picurl: '',
        videoUrl: '',
        hot: '',
        discount: '',
        discountPrice: '',
      },
      form: {
        date1: '',
        date2: '',
        skillprice: '',
      },
    };
  },
  created() {
    this.getcourselist();
  },
  methods: {
    stickYesOrNo(row) {
      // console.log(row);
      if (row.recom === true) {
        let orgid = window.sessionStorage.getItem('orgid');
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let pro = this.$http({
          url: '/edu/mall/book/recommend',
          method: 'POST',
          data: {
            bookId: row.id,
            recomNumber: 0,
          },
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result, 'sas');
            if (result.data.code === 0) {
              this.$message.success('设置成功！');
              this.disabled=false;
            }
            // this.getcourselist();
          })
          .catch((err) => {
            // console.log('error===============')
            this.$message.error('设置失败：' + err);
          });
      } else {
        let orgid = window.sessionStorage.getItem('orgid');
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let pro = this.$http({
          url: '/edu/mall/book/recommend/' + row.id + '/del',
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result, 'sas');
            if (result.data.code === 0) {
              this.$message.success('取消成功！');
            }
            // this.getcourselist();
          })
          .catch((err) => {
            // console.log('error===============')
            this.$message.error('取消失败：' + err);
          });
      }
    },
    //编辑推荐值
    recommend(row){
      console.log(row);
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/book/recommend/'+row.id+'/upd/'+row.recomNumber,
        method:'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'sas');
          if (result.data.code === 0) {
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('编辑失败' + err);
        });
    },
    //查询列表
    getcourselist() {
      if (!this.value1) {
        this.value1 = [];
      }
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/books/' + orgid + '?' + 'page=' + this.page + '&pageSize=' + this.pageSize,
        params:{
          isRecom:this.stick,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'sas');
          if (result.data.code === 0) {
            this.tableData = result.data.data;
            this.total = result.data.size;
            for (let i = 0; i < this.tableData.length; i++) {
              let str = this.tableData[i].createDate;
              var dateee = new Date(str).toJSON();
              var date = new Date(+new Date(dateee) + 8 * 3600 * 1000)
                .toISOString()
                .replace(/T/g, ' ')
                .replace(/\.[\d]{3}Z/, '');
              this.tableData[i].createDate = date;
            }
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('查询失败' + err);
        });
    },
    //查看课程
    lookcourses(row) {
      // console.log(row);
      this.$router.push({ path: '/catalogue', query: { id: row.id } });
    },
    lookcourse(row) {
      // console.log(row);
      this.$router.push({ path: '/newcourse', query: { id: row.id } });
    },
    onSelectedDrug(e) {
      // console.log(e, 'value?');
      this.typeLabelValue = e;
    },
  },
};
</script>

<style lang="less" scoped>
.press {
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 135px;
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar-uploader {
    img {
      width: 120px;
      height: 120px;
    }
  }
  .class_type {
    display: inline-block;
    margin-left: 1330px;
    margin-bottom: 20px;
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
  .course_label {
    display: inline-block;
    margin: 3px 5px;
    padding: 0 10px;
  }
  .create_date {
    display: inline-block;
    margin-left: 20px;
  }
}
</style>
